import http from 'axios'
import { formatQuery, deleteUseless } from '../../lib/formatParams/index'

export default {
  namespaced: true,
  state: {
    guid: "",
    agentInfo: {},
    smsCodeTimeOut: false
  },
  actions: {
    // 获取图形验证码
    getGraphicalCode({ commit }, params) {
      const url = params.source === "loginReg" ? "/v1/register/GetVerificationImg" : "/v1/promoter/GetChangePhoneImgCode"
      return new Promise((resolve, reject) => {
        http.get(url)
          .then(({ data }) => {
            if (data.s === 10006) {
              commit("updateGuid", data.list)
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 获取手机验证码
    getSmsCode({ state, commit }, params) {
      const { source, type, imgCode, mobile } = params
      let url = ""
      if (source === "reg") {
        url =  "/v1/register/CheckVerificationCode"
      } else  if (source === "login") {
        url =  "/v1/register/GetLoginCode"
      } else if (source === "oldMobile") {
        url =  "/v1/register/GetUpdateMobileBind"
      } else if (source === "newMobile") {
        url =  "/v1/register/GetNewMobileBindCode"
      } else if (source === "realname") {
        url =  "/v1/register/GetLoginCodeByTrueName"
      } else if (source === "seeRealname") {
        url = "/v1/register/ChangeBanknoGetSmsCode"
      }
      return new Promise((resolve, reject) => {
        http.get(url + formatQuery(deleteUseless({ mobile, imgCode, type, guid: state.guid })) )
        .then(({ data }) => {
          if (data.s === 10006) {
            resolve(data)
          } else {
            if (data.s === 10002) {
              commit("updataSmsCodeTimeOut", true)
            }
            reject(data)
          }
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    // 获取当前机构协议
    GetAgreement() {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetAgreement")
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 如果推广注册也带了userid ，则返回推广者信息
    GetAgentPeomoterCode({ commit }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/register/GetAgentPeomoterCode" + formatQuery(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              commit("updataAgentInfo", data.list)
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 漂浮负责人信息 返回0无负责人，否则返回负责人信息
    GetAgentPeomoterInfo({ commit }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/register/GetAgentPeomoterInfo")
          .then(({ data }) => {
            if (data.s === 10006) {
              commit("updataAgentInfo", data.list)
              resolve(data.list)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    }
  },
  mutations: {
    updateGuid(state, params) {
      state.guid = params
    },
    updataAgentInfo(state, params) {
      state.agentInfo = params
    },
    updataSmsCodeTimeOut(state, params) {
      state.smsCodeTimeOut = params
    }
  },
  getters: {
    guid(state) {
      return state.guid
    },
    agentInfo(state) {
      return state.agentInfo
    },
    smsCodeTimeOut(state) {
      return state.smsCodeTimeOut
    }
  }
}